import React from 'react'
import type { BaseWeatherIconProps } from '../WeatherIcon'

const WeatherIconSleet: React.FC<BaseWeatherIconProps> = ({
  className = '',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="none"
      className={className}
    >
      <path
        d="M69.1768 70.1446L71.8768 72.1001L74.4434 68.5668L77.0101 72.1001L79.7101 70.1446L77.1434 66.6001L81.299 65.2557L80.2657 62.089L76.1101 63.4334V59.0557H72.7768V63.4334L68.6212 62.089L67.5879 65.2557L71.7434 66.6001L69.1768 70.1446Z"
        fill="#D2E0FF"
      />
      <path
        d="M71.377 79.8667L67.2214 81.2112V76.8445H63.8881V81.2112L59.7326 79.8667L58.6992 83.0334L62.8548 84.3778L60.2881 87.9223L62.9881 89.8778L65.5548 86.3445L68.1214 89.8778L70.8214 87.9223L68.2548 84.3778L72.4103 83.0334L71.377 79.8667Z"
        fill="#D2E0FF"
      />
      <path
        d="M90.1877 83.0334L89.1543 79.8667L84.9988 81.2112V76.8445H81.6655V81.2112L77.5099 79.8667L76.4766 83.0334L80.6321 84.3778L78.0655 87.9223L80.7655 89.8778L83.3321 86.3445L85.8988 89.8778L88.5988 87.9223L86.0321 84.3778L90.1877 83.0334Z"
        fill="#D2E0FF"
      />
      <path
        d="M22.4883 79.8667L18.3217 81.2112V76.8445H14.9883V81.2112L10.8439 79.8667L9.81055 83.0334L13.9661 84.3778L11.3883 87.9223L14.0883 89.8778L16.655 86.3445L19.2328 89.8778L21.9328 87.9223L19.355 84.3778L23.5217 83.0334L22.4883 79.8667Z"
        fill="#D2E0FF"
      />
      <path
        d="M37.0225 59.0667L27.4336 85.7333H32.1669L41.7558 59.0667H37.0225Z"
        fill="#87D6F8"
      />
      <path
        d="M46.7002 59.0667L37.1113 85.7333H41.8447L51.4335 59.0667H46.7002Z"
        fill="#87D6F8"
      />
      <path
        d="M56.3766 59.0667L46.7988 85.7333H51.5211L61.1099 59.0667H56.3766Z"
        fill="#87D6F8"
      />
      <path
        d="M27.5001 59.0667L22.6445 72.4H27.3779L32.2223 59.0667H27.5001Z"
        fill="#87D6F8"
      />
      <path
        d="M73.4445 34.8111H68.3667V29.8666C68.3667 18.9555 59.2667 10.1111 48.0444 10.1111C42.8222 10.1111 38.1333 12.0778 34.5556 15.2333C31.6556 17.7889 29.4667 21.1111 28.4556 24.9222H27.7333C23.5 24.9222 19.6667 26.6111 16.9111 29.3222C14.1889 32 12.5 35.6778 12.5 39.7333C12.5 47.9111 19.3222 54.5444 27.7333 54.5444H32.8111H63.2889H73.4445C79.0556 54.5444 83.6 50.1222 83.6 44.6666C83.6 39.2333 79.0556 34.8111 73.4445 34.8111Z"
        fill="#87D6F8"
      />
    </svg>
  )
}

export default WeatherIconSleet
